import React, { useCallback } from "react";
import { Await, useLoaderData } from "react-router-dom";
import { useAccount } from "../../../Account";
import {
  cancelHold,
  getHoldsSortable,
  unsuspendHold,
} from "../../../services/Holds";
import { holdsLoader } from "./holdsLoader";
import { getKeyForHold, HoldsSharedView } from "./HoldsSharedView";
import { LSResultItemListWithToolbarSkeleton } from "../../search/ls/LSResultItem/LSResultItemListWithToolbarSkeleton";
import { HoldsSelectionProvider } from "./HoldsSelectionContext";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";

export const BorrowerHoldsView: React.FC = () => {
  const { accountSummary, patron } = useAccount();
  const { data, pageSize } = useLoaderData() as {
    data: Promise<typeof holdsLoader>;
    pageSize: number;
  };

  const getId = useCallback(
    (item: HostSystemItemView) => getKeyForHold(item),
    [],
  );

  return (
    <React.Suspense
      fallback={
        <LSResultItemListWithToolbarSkeleton
          pageSize={pageSize}
          hideCheckbox={false}
          hideActions={false}
        />
      }
    >
      <Await resolve={data}>
        {({ sort, page, pageSize, holds, totalHolds, totalArrivedHolds }) => {
          return (
            <HoldsSelectionProvider items={holds} getId={getId}>
              <HoldsSharedView
                page={page}
                pageSize={pageSize}
                sort={sort}
                isStudent={false}
                holds={holds}
                patronId={patron?.patronId}
                digitalInformationLastUpdated={
                  accountSummary?.digitalInformationLastUpdated
                }
                cancelHoldsApi={cancelHold}
                unsuspendHoldsApi={unsuspendHold}
                totalHolds={totalHolds}
                totalArrivedHolds={totalArrivedHolds}
                fetchPrintHolds={async () => {
                  const response = await getHoldsSortable(
                    0,
                    totalHolds,
                    sort,
                    true,
                  );
                  return response.holds;
                }}
              />
            </HoldsSelectionProvider>
          );
        }}
      </Await>
    </React.Suspense>
  );
};
